import { useEffect } from "react"
import { closeDrops, closeModal } from "../utils"
import { resetSelected } from "../store/actions/track"

export const useDropClose = () => {
  const elems = document.querySelectorAll("li")
  elems.forEach((el) => {
    el.addEventListener("click", closeDrops)
  })
}

export const useModalClose = (target: string, cls: string) => {
  const elems = document.querySelectorAll(`.${cls}`)
  elems.forEach((el) => {
    el.addEventListener("click", () => {
      closeModal(target)
    })
  })
}

export const useSelectedReset = (id: string) => {
  useEffect(() => {
    document.getElementById(id)?.addEventListener("hidden", () => {
      resetSelected()
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
}
